export function isAnyTagBlacklisted(blacklistedTags, tags) {
  return typeof tags.find(tag => isTagBlacklisted(blacklistedTags, tag.id)) !== 'undefined'
}

function isTagBlacklisted(blacklistedTags, id) {
  return blacklistedTags.contains(id)
}
